import { RmnRegion } from './rmn-region';

export class RmnMainRegion extends RmnRegion {
  type?: string;
}
